module.exports = __webpack_public_path__ + "static/media/draw-square.87552903.svg";